module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-01.f1f5321f.png";